<template>
  <Card
    title="Admin Info"
    direction="column"
    color="background"
    background="black"
  >
    <TextComponent color="background" type="paragraph" as="p">
      Id:

      {{ data._id }}
    </TextComponent>
    <TextComponent as="p" color="background" type="paragraph">
      Updated At: {{ date(data.hackerApplication.lastUpdated) }}
    </TextComponent>
    <TextComponent color="background" type="paragraph" as="p">
      Created At: {{ date(data.created) }}
    </TextComponent>
    <TextComponent color="background" type="paragraph" as="p">
      APP Open: {{ date(data.computedApplicationOpen) }}
    </TextComponent>
    <TextComponent color="background" type="paragraph" as="p">
      APP Deadline: {{ date(data.computedApplicationDeadline) }}
    </TextComponent>
    <TextComponent color="background" type="paragraph" as="p">
      RSVP Deadline: {{ date(data.computedRSVPDeadline) }}
    </TextComponent>
    <TextComponent color="background" type="paragraph" as="p">
      Resume Permission:
      {{ data.hackerApplication.resumeSharePermission ? 'Yes' : 'No' }}
    </TextComponent>
    <TextComponent color="background" type="paragraph" as="p">
      Computed Application Score: {{ data.internal.computedApplicationScore }}
    </TextComponent>
    <Stack direction="column" spacing="none">
      <TextComponent color="background" type="paragraph" as="p">
        Notes
      </TextComponent>
      <TextComponent color="background" type="body1">
        {{ data.internal.notes }}
      </TextComponent>
    </Stack>
  </Card>
</template>

<script>
  import Stack from '@hackthe6ix/vue-ui/Stack';
  import TextComponent from '@hackthe6ix/vue-ui/Text';
  import Card from '../../../../containers/Card';

  const format = new Intl.DateTimeFormat(`en`, {
  minute: 'numeric',
  year: 'numeric',
  hour: 'numeric',
  day: 'numeric',
  month: 'short',
}).format;

export default {
  name: 'AdminInfo',
  components: {
    TextComponent,
    Stack,
    Card,
  },
  methods: {
    date(_) {
      return _ ? format(new Date(parseInt(_))) : 'N/A';
    },
  },
  props: {
    data: Object,
  },
};
</script>
